<template>
    <textarea
        v-bind="$attrs"
        class="px-3 py-2 shadow-xs bg-white border border-stone-200 rounded-lg2 placeholder-gray-300 w-full disabled:bg-stone-100 disabled:text-gray-500 disabled:select-none disabled:cursor-not-allowed"
        :class="{
            'focus:ring-primary focus:border-primary':
                !useBookingFormThemeCssVariables,
            'focus:ring-booking-form-theme-main-background-color focus:border-booking-form-theme-main-background-color':
                useBookingFormThemeCssVariables,
        }"
        type="text"
        @input="handleInputEvent($event)"
        >{{ modelValue }}</textarea>
</template>

<script setup lang="ts">
    const emits = defineEmits<{
        'update:modelValue': [value: string | null]
    }>()

    defineProps({
        modelValue: {
            type: [String, Number, Boolean],
            default: null,
        },
        useBookingFormThemeCssVariables: {
            type: Boolean,
            default: false,
        },
    })

    const handleInputEvent = (event: Event) => {
        const target = event.target as HTMLInputElement | null
        const value = target?.value ?? null
        emits('update:modelValue', value)
    }
</script>
